import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Typography } from 'antd'

const SpecialAuthorizationFormHistoryModal = ({
  title,
  width,
  visible,
  onCancel,
  children,
  ...props
}) => (
  <Modal
    visible={visible}
    onCancel={onCancel}
    footer={null}
    closable={false}
    centered
    width={width}
    destroyOnClose
    maskStyle={{
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(10px)',
    }}
    {...props}
  >
    <Typography.Title level={3}>{title}</Typography.Title>
    {children}
  </Modal>
)

SpecialAuthorizationFormHistoryModal.propTypes = {
  title: PropTypes.string,
  width: PropTypes.number,
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
}

SpecialAuthorizationFormHistoryModal.defaultProps = {
  title: '',
  width: 800,
}

export default SpecialAuthorizationFormHistoryModal
